import api from './api';
import { Trail } from '../types';

export const trailsService = {
  getAll: async (): Promise<Trail[]> => {
    const response = await api.get<Trail[]>('/trails');
    return response.data;
  },

  getOne: async (id: string): Promise<Trail> => {
    const response = await api.get<Trail>(`/trails/${id}`);
    return response.data;
  },

  create: async (data: Partial<Trail>): Promise<Trail> => {
    const response = await api.post<Trail>('/trails', data);
    return response.data;
  },

  update: async (id: string, data: Partial<Trail>): Promise<Trail> => {
    const response = await api.patch<Trail>(`/trails/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/trails/${id}`);
  },
};
